// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".helper[data-v-62720bc8]{font-size:14px;line-height:1;text-align:center}.ico-red-tips[data-v-62720bc8]{width:8px;height:8px;border-radius:50%;background:#ff2500;position:absolute;right:30px;top:50%;margin-top:-5px}", ""]);
// Exports
module.exports = exports;
